import './style.css';
import { Game } from './game/Game';

const game = new Game();
game.init();

window.addEventListener('beforeunload', () => {
  game.cleanup();
});